<template>
  <div class="social-share">
    <button
      v-for="item of $tm('metaContent.socialMedia')"
      class="social-share__button"
      :key="item.social"
      :aria-label="item.social"
      :icon="icons[item.social]"
    >
      <ShareNetwork
        :network="item.social"
        :url="socialUrl"
        :title="$t('metaContent.title')"
        :description="$t('metaContent.description')"
      >
        <icon
          class="social-share__content__icon"
          :data="icons[item.social]"
          width="0.75rem"
          height="0.75rem"
          :color="`var(--${smallscreen ? 'white' : 'white'}-100)`"
        />
      </ShareNetwork>
    </button>
  </div>
</template>

<script setup>
import { facebook, twitter, linkedin } from "@/assets/icons/icons.js";

defineProps({
  smallscreen: Boolean,
});

// TODO: what should this be?
const socialUrl = window.location.href;
const icons = { facebook, twitter, linkedin };
</script>

<style lang="scss" scoped>
.social-share {
  position: relative;
  display: flex;
  gap: 0.5rem;

  .mobile &,
  .tablet & {
    justify-content: center;
    gap: 1.75rem;
    .social-share__button {
      border-color: var(--white-100);
    }
  }

  &__button {
    border-radius: 50%;
    width: toRem(32);
    height: toRem(32);
    border: 1px solid var(--scala-grigi-gray-2);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    transition: border-color 0.3s;

    &:hover {
      border-color: var(--white-100);
    }
  }
}
</style>
